import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "../../../Slice/AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";



const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");
const DataBase = Cookies.get("Database");

export const ColourFilter = createAsyncThunk("ColorMain/ColorFilters", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ColorFilters`,
            { DataBase: DataBase },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const ColourFilterTable = createAsyncThunk("ColorMain/ColorInwardAnalysis", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/ColorInwardAnalysis`,
            {
                StartDate: payload.StartDate ? payload.StartDate : "",
                EndDate: payload.EndDate ? payload.EndDate : "",
                FirmIDs: payload.FirmIDs,
                DataBase: DataBase,
                
                AcIDs: payload.AcIDs ? payload.AcIDs : "",
                ItemIDs: payload.ItemIDs ? payload.ItemIDs : "",
                BookIDs: payload.BookIDs ? payload.BookIDs : "",
                FieldList: payload.FieldList ? payload.FieldList : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const ProductionTUCTable = createAsyncThunk("ColorMain/ColorProductionUptoCost", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/ColorProductionUptoCost`,
            {
                StartDate: payload.StartDate ? payload.StartDate : "",
                EndDate: payload.EndDate ? payload.EndDate : "",
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupIDs: payload.ProductionGroupIDs ? payload.ProductionGroupIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const ColorMasterGrpProdAndCostTable = createAsyncThunk("ColorMain/ColorMasterGrpProdAndCost", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/ColorMasterGrpProdAndCost`,
            {
                StartDate: payload.StartDate ? payload.StartDate : "",
                EndDate: payload.EndDate ? payload.EndDate : "",
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                DataBase: DataBase,
                
                ProductionGroupIDs: payload.ProductionGroupIDs ? payload.ProductionGroupIDs : "",
                MachineGroupMstIDs: payload.MachineIDs ? payload.MachineIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ColorMasterGrpUptoCostTable = createAsyncThunk("ColorMain/ColorMasterGrpUptoCost", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/ColorMasterGrpUptoCost`,
            {
                StartDate: payload.StartDate ? payload.StartDate : "",
                EndDate: payload.EndDate ? payload.EndDate : "",
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupIDs: payload.ProductionGroupIDs ? payload.ProductionGroupIDs : "",
                MachineGroupMstIDs: payload.MachineGroupIDs ? payload.MachineGroupIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

// =============  Page no 7 API ========= //
export const ColorMasterwise7Table = createAsyncThunk("ColorMain/Masterwise7", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/Masterwise7`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupIDs: payload.ProductionGroupIds,
                MachineGroupMstIDs: payload.MachineGroupMstIDs,
                MachineMstIDs: payload.MachineIds,
                EndDate: payload.EndDate,
                StartDate: payload.StartDate,
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

// =================== Page no 12  ==============================  //
export const ColorMasterwise12Table = createAsyncThunk("ColorMain/Masterwise12", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/Masterwise12`,
            {
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                DataBase: DataBase,
                
                monthIds: payload.monthIds ? payload.monthIds : "",
                ItemSubG: payload.ItemSubG,

            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

// =================== Page no 13 ========================== //

export const ColorMasterwise13Table = createAsyncThunk("ColorMain/Masterwise13", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/Masterwise13`,
            {
                FirmIDs: Firm,
                AcYearIDs: FinancialYear,
                DataBase: DataBase,
                
                monthIds: payload.monthIds ? payload.monthIds : "",
                ItemSubG: payload.ItemSubG ? payload.ItemSubG : "",

            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

// ================== Page no 14 ========================== //

export const ColorMasterwise14Table = createAsyncThunk("ColorMain/Masterwise14", async (payload) => {
    try {
        const response = await api.post(
            `/ColorMain/Masterwise14`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                monthIds: payload.monthIds ? payload.monthIds : "",
                ItemSubG: payload.ItemSubG,
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const MonthWiseProdGrpWise = createAsyncThunk("ColorMain/MonthWiseProdGrpWise", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/MonthWiseProdGrpWise`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupIDs: data.ProductionGroupIDs ? data.ProductionGroupIDs : "",
                monthIds: data.monthIds ? data.monthIds : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const PartyVsItem = createAsyncThunk("ColorMain/PartyVsItem", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/PartyVsItem`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                AcIDs: data.AcIDs ? data.AcIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ItemVsSupplier = createAsyncThunk("ColorMain/ItemVsSupplier", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ItemVsSupplier`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ItemSubGrpIDsIDs: data.ItemSubGrpIDsIDs ? data.ItemSubGrpIDsIDs : "",
                ItemIDs: data.ItemIDs ? data.ItemIDs : "",
                ItemGrpIDs: data.ItemGrpIDs ? data.ItemGrpIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ProdGrpMonthlyCon = createAsyncThunk("ColorMain/ProdGrpMonthlyCon", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ProdGrpMonthlyCon`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ProdGrpMCGrpCost = createAsyncThunk("ColorMain/ProdGrpMCGrpCost", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ProdGrpMCGrpCost`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : "",
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ProdGrpMachineWise = createAsyncThunk("ColorMain/ProdGrpMachineWise", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ProdGrpMachineWise`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                monthIds: data.monthIds ? data.monthIds : "",
                ProductionGroupIDs: data.ProductionGroupIDs ? data.ProductionGroupIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ProdGrpMachineWiseCon = createAsyncThunk("ColorMain/ProdGrpMachineWiseCon", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ProdGrpMachineWiseCon`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                monthIds: data.monthIds ? data.monthIds : "",
                ProductionGroupMstIDs: data.ProductionGroupMstIDs ? data.ProductionGroupMstIDs : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const MonthlyStock = createAsyncThunk("ColorMain/MonthlyStock", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/MonthlyStock`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                ItemGroupIDs: data.ItemGroupIDs ? data.ItemGroupIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});

export const ProdGrpMachineGrpWise = createAsyncThunk("ColorMain/ProdGrpMachineGrpWise", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/ProdGrpMachineGrpWise`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIds: FinancialYear,
                ProductionGroupIDs: data.ProductionGroupIDs ? data.ProductionGroupIDs : "",
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                monthIds: data.monthIds ? data.monthIds : ""
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});


export const MachineWiseCosting = createAsyncThunk("ColorMain/MachineWiseCosting", async (data) => {
    try {
        const response = await api.post(
            `/ColorMain/MachineWiseCosting`,
            {
                FirmIDs: Firm,
                DataBase: DataBase,
                
                AcYearIDs: FinancialYear,
                MachineGroupMstIDs: data.MachineGroupMstIDs ? data.MachineGroupMstIDs : "",
                ProductionGroupIDs: data.ProductionGroupIDs ? data.ProductionGroupIDs : "",
                StartDate: data.StartDate ? data.StartDate : "",
                EndDate: data.EndDate ? data.EndDate : "",
            },
         
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : "Network Error");
    }
});




const InwardAnalysisSlice = createSlice({
    name: 'InwardAnalysisSlice',
    initialState: {
        ColourfilterData: null,
        isFilterLoading: false,
        filterError: null,

        ColourFilterDataTable: null,
        isTableFilterLoading: false,
        TableFilterError: null,

        ProductionTUCDataTable: null,
        isProductionTUCLoading: false,
        ProductionTUCError: null,

        ColorMasterGrpProdAndCostTableData: null,
        isColorMasterGrpProdAndCostLoading: false,
        ColorMasterGrpProdAndCostError: null,

        ColorMasterGrpUptoCostTableData: null,
        isColorMasterGrpUptoCostLoading: false,
        ColorMasterGrpUptoCostError: null,

        ColorMasterwise7TableData: null,
        isColorMasterwise7Loading: false,
        ColorMasterwise7Error: null,

        ColorMasterwise12TableData: null,
        isColorMasterwise12Loading: false,
        ColorMasterwise12Error: null,

        ColorMasterwise13TableData: null,
        isColorMasterwise13Loading: false,
        ColorMasterwise13Error: null,

        ColorMasterwise14TableData: null,
        isColorMasterwise14Loading: false,
        ColorMasterwise14Error: null,
        MonthWiseProdGrpWisedata: null,
        PartyVsItemdata: null,
        ItemVsSupplierdata: null,
        ProdGrpMonthlyCondata: null,
        ProdGrpMCGrpCostdata: null,
        ProdGrpMachineWisedata: null,
        ProdGrpMachineWiseCondata: null,
        MonthlyStockdata: null,
        ProdGrpMachineGrpWisedata: null,
        MachineWiseCostingdata: null,
    },
    reducers: {
        ColourfilterFun: (state) => {
            state.ColourfilterData = "no";
        },
        ColourFilterTableFun: (state) => {
            state.ColourFilterDataTable = "no";
        },
        ProductionTUCTableFun: (state) => {
            state.ProductionTUCDataTable = "no";
        },
        ColorMasterGrpUptoCostTableFun: (state) => {
            state.ColorMasterGrpUptoCostTableData = "no";
        },
        ColorMasterGrpProdAndCostTableFun: (state) => {
            state.ColorMasterGrpProdAndCostTableData = "no";
        },
        ColorMasterwise7TableFun: (state) => {
            state.ColorMasterwise7TableData = "no";
        },
        ColorMasterwise12TableFun: (state) => {
            state.ColorMasterwise12TableData = "no";
        },
        ColorMasterwise13TableFun: (state) => {
            state.ColorMasterwise13TableData = "no";
        },
        ColorMasterwise14TableFun: (state) => {
            state.ColorMasterwise14TableData = "no";
        },
        MonthWiseProdGrpWiseFun: (state) => {
            state.MonthWiseProdGrpWisedata = "no";
        },
        ProdGrpMonthlyConFun: (state) => {
            state.ProdGrpMonthlyCondata = "no";
        },
        ProdGrpMonthlyConFun: (state) => {
            state.ProdGrpMonthlyCondata = "no";
        },
        ProdGrpMachineWiseFun: (state) => {
            state.ProdGrpMachineWisedata = "no";
        },
        ProdGrpMachineWiseConFun: (state) => {
            state.ProdGrpMachineWiseCondata = "no";
        },
        MonthlyStockFun: (state) => {
            state.MonthlyStockdata = "no";
        },
        ProdGrpMachineGrpWiseFun: (state) => {
            state.ProdGrpMachineGrpWisedata = "no";
        },
        ItemVsSupplierFun: (state) => {
            state.ItemVsSupplierdata = "no";
        },

        PartyVsItemFun: (state) => {
            state.PartyVsItemdata = "no";
        },
        MachineWiseCostingFun: (state) => {
            state.MachineWiseCostingdata = "no";
        },
        ProdGrpMCGrpCostFun: (state) => {
            state.ProdGrpMCGrpCostdata = "no";
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(ColourFilter.pending, (state) => {
                state.isFilterLoading = true;
                state.filterError = null;
            })

            .addCase(ColourFilter.fulfilled, (state, action) => {
                state.isFilterLoading = false;
                state.ColourfilterData = action.payload;
            })

            .addCase(ColourFilter.rejected, (state, action) => {
                state.isFilterLoading = false;
                state.filterError = action.payload;
            });

        builder

            .addCase(ColourFilterTable.pending, (state) => {
                state.isTableFilterLoading = true;
                state.TableFilterError = null;
            })

            .addCase(ColourFilterTable.fulfilled, (state, action) => {
                state.isTableFilterLoading = false;
                state.ColourFilterDataTable = action.payload;
            })

            .addCase(ColourFilterTable.rejected, (state, action) => {
                state.isTableFilterLoading = false;
                state.TableFilterError = action.payload;
            });


        builder

            .addCase(ProductionTUCTable.pending, (state) => {
                state.isProductionTUCLoading = true;
                state.ProductionTUCError = null;
            })

            .addCase(ProductionTUCTable.fulfilled, (state, action) => {
                state.isProductionTUCLoading = false;
                state.ProductionTUCDataTable = action.payload;
            })

            .addCase(ProductionTUCTable.rejected, (state, action) => {
                state.isProductionTUCLoading = false;
                state.ProductionTUCError = action.payload;
            });


        builder

            .addCase(ColorMasterGrpProdAndCostTable.pending, (state) => {
                state.isColorMasterGrpProdAndCostLoading = true;
                state.ColorMasterGrpProdAndCostError = null;
            })

            .addCase(ColorMasterGrpProdAndCostTable.fulfilled, (state, action) => {
                state.isColorMasterGrpProdAndCostLoading = false;
                state.ColorMasterGrpProdAndCostTableData = action.payload;
            })

            .addCase(ColorMasterGrpProdAndCostTable.rejected, (state, action) => {
                state.isColorMasterGrpProdAndCostLoading = false;
                state.ColorMasterGrpProdAndCostError = action.payload;
            });

        builder

            .addCase(ColorMasterGrpUptoCostTable.pending, (state) => {
                state.isColorMasterGrpUptoCostLoading = true;
                state.ColorMasterGrpUptoCostError = null;
            })

            .addCase(ColorMasterGrpUptoCostTable.fulfilled, (state, action) => {
                state.isColorMasterGrpUptoCostLoading = false;
                state.ColorMasterGrpUptoCostTableData = action.payload;
            })

            .addCase(ColorMasterGrpUptoCostTable.rejected, (state, action) => {
                state.isColorMasterGrpUptoCostLoading = false;
                state.ColorMasterGrpUptoCostError = action.payload;
            });

        //  ==============Page no 7 API  ==========//
        builder

            .addCase(ColorMasterwise7Table.pending, (state) => {
                state.isColorMasterwise7Loading = true;
                state.ColorMasterwise7Error = null;
            })

            .addCase(ColorMasterwise7Table.fulfilled, (state, action) => {
                state.isColorMasterwise7Loading = false;
                state.ColorMasterwise7TableData = action.payload;
            })

            .addCase(ColorMasterwise7Table.rejected, (state, action) => {
                state.isColorMasterwise7Loading = false;
                state.ColorMasterwise7Error = action.payload;
            });


        //  ==============Page no 12 API  ==========//
        builder

            .addCase(ColorMasterwise12Table.pending, (state) => {
                state.isColorMasterwise12Loading = true;
                state.ColorMasterwise12Error = null;
            })

            .addCase(ColorMasterwise12Table.fulfilled, (state, action) => {
                state.isColorMasterwise12Loading = false;
                state.ColorMasterwise12TableData = action.payload;
            })

            .addCase(ColorMasterwise12Table.rejected, (state, action) => {
                state.isColorMasterwise12Loading = false;
                state.ColorMasterwise12Error = action.payload;
            });

        //  ==============Page no 13 API  ==========//
        builder

            .addCase(ColorMasterwise13Table.pending, (state) => {
                state.isColorMasterwise13Loading = true;
                state.ColorMasterwise13Error = null;
            })

            .addCase(ColorMasterwise13Table.fulfilled, (state, action) => {
                state.isColorMasterwise13Loading = false;
                state.ColorMasterwise13TableData = action.payload;
            })

            .addCase(ColorMasterwise13Table.rejected, (state, action) => {
                state.isColorMasterwise13Loading = false;
                state.ColorMasterwise13Error = action.payload;
            });


        //  ==============Page no 14 API  ==========//
        builder

            .addCase(ColorMasterwise14Table.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ColorMasterwise14Table.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14TableData = action.payload;
            })

            .addCase(ColorMasterwise14Table.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });

        builder

            .addCase(MonthWiseProdGrpWise.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(MonthWiseProdGrpWise.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.MonthWiseProdGrpWisedata = action.payload;
            })

            .addCase(MonthWiseProdGrpWise.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });


        builder

            .addCase(PartyVsItem.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(PartyVsItem.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.PartyVsItemdata = action.payload;
            })

            .addCase(PartyVsItem.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });

        builder

            .addCase(ItemVsSupplier.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ItemVsSupplier.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ItemVsSupplierdata = action.payload;
            })

            .addCase(ItemVsSupplier.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });


        builder

            .addCase(ProdGrpMonthlyCon.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ProdGrpMonthlyCon.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ProdGrpMonthlyCondata = action.payload;
            })

            .addCase(ProdGrpMonthlyCon.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });


        builder

            .addCase(ProdGrpMCGrpCost.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ProdGrpMCGrpCost.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ProdGrpMCGrpCostdata = action.payload;
            })

            .addCase(ProdGrpMCGrpCost.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });


        builder

            .addCase(ProdGrpMachineWise.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ProdGrpMachineWise.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ProdGrpMachineWisedata = action.payload;
            })

            .addCase(ProdGrpMachineWise.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });


        builder
            .addCase(ProdGrpMachineWiseCon.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ProdGrpMachineWiseCon.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ProdGrpMachineWiseCondata = action.payload;
            })

            .addCase(ProdGrpMachineWiseCon.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });

        builder
            .addCase(MonthlyStock.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(MonthlyStock.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.MonthlyStockdata = action.payload;
            })

            .addCase(MonthlyStock.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });

        builder
            .addCase(ProdGrpMachineGrpWise.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(ProdGrpMachineGrpWise.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ProdGrpMachineGrpWisedata = action.payload;
            })

            .addCase(ProdGrpMachineGrpWise.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });

        builder
            .addCase(MachineWiseCosting.pending, (state) => {
                state.isColorMasterwise14Loading = true;
                state.ColorMasterwise14Error = null;
            })

            .addCase(MachineWiseCosting.fulfilled, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.MachineWiseCostingdata = action.payload;
            })

            .addCase(MachineWiseCosting.rejected, (state, action) => {
                state.isColorMasterwise14Loading = false;
                state.ColorMasterwise14Error = action.payload;
            });
    },
});
export const { ColourfilterFun, ColourFilterTableFun, ColorMasterGrpProdAndCostTableFun, ColorMasterwise14TableFun, ColorMasterwise13TableFun, ColorMasterwise12TableFun, ColorMasterwise7TableFun, ColorMasterGrpUptoCostTableFun, ProductionTUCTableFun, MonthWiseProdGrpWiseFun, ProdGrpMonthlyConFun, ProdGrpMachineWiseFun, ProdGrpMCGrpCostFun, MachineWiseCostingFun, ProdGrpMachineGrpWiseFun, PartyVsItemFun, ItemVsSupplierFun, ProdGrpMachineWiseConFun, MonthlyStockFun } = InwardAnalysisSlice.actions;
export default InwardAnalysisSlice.reducer;